// Sentinel's labels and the rules that hang off them. This file imports nothing, so the Sentinel workflow can load
// it inside Temporal's sandbox, which never loads the rest of this package.
// What Sentinel acts on. A label is about what the caller is doing on the call, never about what the call is about.
export const SENTINEL_LABELS = [
    'prompt_injection',
    'self_harm',
    'threats',
    'abuse',
    'sexual_content',
    'filtered_content'
];
// What the judging model may answer. For prompt injection it names the kind it saw; the other labels have one
// category each.
export const SENTINEL_JUDGED_CATEGORIES = [
    'none',
    'instruction_override',
    'prompt_extraction',
    'persona_change',
    'authority_claim',
    'self_harm',
    'threats',
    'abuse',
    'sexual_content'
];
// A verdict's category: one the model answered, or filtered_content, which the model never answers. It stands for a
// turn the model's provider refused to read at all, which happens on the most graphic threats and sexual talk.
export const SENTINEL_CATEGORIES = [...SENTINEL_JUDGED_CATEGORIES, 'filtered_content'];
const LABEL_BY_CATEGORY = {
    instruction_override: 'prompt_injection',
    prompt_extraction: 'prompt_injection',
    persona_change: 'prompt_injection',
    authority_claim: 'prompt_injection',
    self_harm: 'self_harm',
    threats: 'threats',
    abuse: 'abuse',
    sexual_content: 'sexual_content',
    filtered_content: 'filtered_content'
};
export const sentinelLabelOf = (category) => category === 'none' ? undefined : LABEL_BY_CATEGORY[category];
// The strike at which each label is acted on, until an organization sets its own
export const SENTINEL_DEFAULT_STRIKES = {
    prompt_injection: 2,
    self_harm: 1,
    threats: 1,
    abuse: 3,
    sexual_content: 3,
    filtered_content: 2
};
export const SENTINEL_MIN_STRIKES = 1;
export const SENTINEL_MAX_STRIKES = 5;
// The strikes an organization acts at: the numbers it set, over the defaults
export const withSentinelDefaultStrikes = (changed) => ({ ...SENTINEL_DEFAULT_STRIKES, ...changed });
// How sure the judge says it is of a verdict, least sure first
export const SENTINEL_CONFIDENCES = ['low', 'medium', 'high'];
// How sure the judge must be for a flag to be a strike. Prompt injection strikes at medium: the judge saves high for
// wording with no ordinary explanation, and a caller hiding an attempt words it to have one.
export const SENTINEL_STRIKE_CONFIDENCE = {
    prompt_injection: 'medium',
    self_harm: 'high',
    threats: 'high',
    abuse: 'high',
    sexual_content: 'high',
    filtered_content: 'high'
};
export const isSureEnoughToStrike = (confidence, needed) => SENTINEL_CONFIDENCES.indexOf(confidence) >= SENTINEL_CONFIDENCES.indexOf(needed);
export const SENTINEL_LABEL_NAMES = {
    prompt_injection: 'Prompt injection',
    self_harm: 'Self-harm',
    threats: 'Threats',
    abuse: 'Abuse',
    sexual_content: 'Sexual content',
    filtered_content: 'Filtered content'
};
//# sourceMappingURL=sentinel-labels.js.map